import i18next, { t as lingoT, Trans as LingoTrans }  from '@tencent/lingo-sdk/dist/react';
import translation_zh from '@i18n/home/zh.json';
import translation_en from '@i18n/home/en.json';
import translation_ja from '@i18n/home/ja.json';
import translation_ko from '@i18n/home/ko.json';
import { getCookie } from '../cookies';

const translation = {
  zh: {
    translation: translation_zh,
  },
  en: {
    translation: translation_en,
  },
  jp: {
    translation: translation_ja,
  }, 
  ko: {
    translation: translation_ko,
  },
};


let initFlag = false;
export function initI18n() {
  if (!initFlag) {
    const lang = window.VERSION || getCookie('saas_intl') || 'en';
    i18next.use({ translation, lang });
    initFlag = true;
  }
}

export { Trans } from './Trans';
export { t } from './t';